import { useCssVars as _useCssVars, unref as _unref } from 'vue';
import { storeToRefs } from 'pinia';
import { useUserStore, useMainStatusStore } from '../../store';
import { rlog } from '../../utils';

import { useRoute } from 'vue-router';
import { showToast } from 'vant/es';
import { unref, computed } from 'vue';
import 'vant/es/toast/style/index';
export default {
  __name: 'SvipTag',
  setup(__props, {
    expose: __expose
  }) {
    __expose();
    _useCssVars(_ctx => ({
      "40d05fe4": _unref(tagWidth)
    }));
    const useStore = useUserStore();
    const {
      isSvip,
      isSlideVip
    } = storeToRefs(useUserStore());
    const useStatusStore = useMainStatusStore();
    const {
      remainInfo
    } = storeToRefs(useStatusStore);
    const route = useRoute();
    const handleVipClick = () => {
      showToast({
        message: '开通会员，畅享PPT生成60次/月，海量风格任你选',
        className: 'c-toast',
        duration: 2000,
        zIndex: 10000
      });
      useStore.changeSvipSource('AIPPT_web_homepage_header_svip_icon');
      useStore.changeVipShow(true);
      const currentSource = route.path === '/home' ? 'AIPPT_web_homepage' : 'AIPPT_web_outlinepage';
      const vipStatus = unref(isSvip) ? 1 : 0;
      let status;
      if (vipStatus === 1) {
        // 超级会员，记录剩余次数情况
        const uses = unref(remainInfo).createOutlineRemain;
        if (uses <= 10) {
          status = '0_10';
        } else if (uses <= 20) {
          status = '10_20';
        } else if (uses <= 30) {
          status = '20_30';
        } else if (uses <= 40) {
          status = '30_40';
        } else if (uses <= 50) {
          status = '40_50';
        } else if (uses <= 60) {
          status = '50_60';
        }
      } else {
        // 非超级会员，记录用完情况
        status = unref(remainInfo).createOutlineRemain === 0 ? 1 : 0;
      }
      rlog([['action', 'AIPPT_web_header_svip_icon_click'], ['source', currentSource], ['status', status]], true);
    };
    const vipText = computed(() => {
      if (unref(isSlideVip) || unref(isSvip)) {
        return 'SVIP会员专享，畅享';
      }
      return '解锁有道权益，畅享智能';
    });
    const tagWidth = computed(() => unref(isSlideVip) || unref(isSvip) ? '122px' : '66px');
    const __returned__ = {
      useStore,
      isSvip,
      isSlideVip,
      useStatusStore,
      remainInfo,
      route,
      handleVipClick,
      vipText,
      tagWidth,
      get storeToRefs() {
        return storeToRefs;
      },
      get useUserStore() {
        return useUserStore;
      },
      get useMainStatusStore() {
        return useMainStatusStore;
      },
      get rlog() {
        return rlog;
      }
    };
    Object.defineProperty(__returned__, '__isScriptSetup', {
      enumerable: false,
      value: true
    });
    return __returned__;
  }
};